import { useState, type ReactNode } from 'react';
import { IconArrowsExchange, IconChevronDown, IconInfoCircle, IconRoute, IconScissors, IconTruck, IconUserPlus, IconListDetails } from '@tabler/icons-react';
import { useToast } from '@hana/ui';
import { ipadDetail } from './ipadDetailData';
import { useT } from '@hana/i18n';
import './i18n';
import s from './ipadDetail.module.css';

// Mint-TMS-iPad (page=detail, khổ 1180): trang chi tiết toàn màn 2:1 — Hành trình GPS · Thông tin chuyến · Người phụ trách + chân Dead run / Cắt mooc / Đổi xe.
// money=hide: không có thẻ "Chi phí từ app tài xế" (chỉ hiện khi xem tiền). Chỉ đọc; Dead run / Cắt mooc / Đổi xe báo toast (giả lập).

function Section({ title, tip, icon, children }: { title: string; tip: string; icon: ReactNode; children: ReactNode }) {
  const [open, setOpen] = useState(true);
  return (
    <section aria-label={title} className={s.card}>
      <div className={s.ch}>
        <span className={s.chIco} aria-hidden="true">{icon}</span>
        <h2 className={s.h2}>{title}</h2>
        <span className={s.tip} role="img" aria-label={`Giải thích: ${tip}`} title={tip}><IconInfoCircle size={14} stroke={1.9} aria-hidden="true" /></span>
        <button type="button" className={`${s.fold} ${open ? s.foldOpen : ''}`} aria-label={`Mở hoặc gập ${title}`} aria-expanded={open} onClick={() => setOpen(!open)}>
          <IconChevronDown size={18} stroke={1.9} aria-hidden="true" />
        </button>
      </div>
      {open && <div className={s.cb}>{children}</div>}
    </section>
  );
}

export function IpadTripDetail({ id, onBack }: { id: string | undefined; onBack: () => void }) {
  const toast = useToast();
  const t = useT();
  const [truck, setTruck] = useState<string | undefined>();
  const d = ipadDetail(id, truck);
  const say = (msg: string) => toast({ msg });
  return (
    <div className={s.wrap}>
      <header className={s.hd}>
        <div className={s.hdRow}>
          <button type="button" className={s.back} aria-label="Quay lại danh sách chuyến" title="Quay lại danh sách chuyến" onClick={onBack}>
            <IconChevronDown size={18} stroke={2} style={{ transform: 'rotate(90deg)' }} aria-hidden="true" />
          </button>
          <h1 className={s.h1}>{d.id}</h1>
          <span className={`${s.badge} ${d.p0 ? s.badgeP0 : ''}`}>{d.status}</span>
        </div>
        <div className={s.sub}>{`${d.job} · Dispatcher ${d.disp}`}</div>
      </header>
      <div className={s.grid}>
        <div className={s.col}>
          <Section title="Hành trình GPS" tip="Mốc theo GPS xe (adsun-proxy) và xác nhận của tài xế trên HANA Mov" icon={<IconRoute size={18} stroke={1.9} />}>
            {d.steps.map((p) => (
              <div key={p.k} className={s.step}>
                <div className={s.rail}>
                  <span className={`${s.dot} ${p.kind === 'done' ? s.dotDone : p.kind === 'cur' ? (p.late ? s.dotCurP0 : s.dotCur) : ''}`} />
                  <span className={`${s.ln} ${p.last ? s.lnEnd : p.kind === 'done' ? s.lnDone : ''}`} />
                </div>
                <div className={s.stRow}>
                  <span className={`${s.stK} ${p.kind === 'done' ? s.stKDone : p.kind === 'cur' ? s.stKCur : ''}`}>{p.k}</span>
                  <span className={s.stAt}>{p.at}</span>
                </div>
              </div>
            ))}
          </Section>
        </div>
        <div className={s.col}>
          <Section title="Thông tin chuyến" tip="Xe, tài xế, cont, hạn và số đo GPS của chuyến" icon={<IconListDetails size={18} stroke={1.9} />}>
            {d.props.map((p) => (
              <div key={p.k} className={s.prop}><span className={s.propK}>{p.k}</span><b className={s.propV}>{p.v}</b></div>
            ))}
          </Section>
          <Section title="Người phụ trách" tip="Người được giao trên chính lệnh vận chuyển: Điều độ (Dispatcher) và tài xế" icon={<IconUserPlus size={18} stroke={1.9} />}>
            {d.pic.map((u) => (
              <div key={u.s} className={s.pic}>
                <span className={s.av} title={u.k}>{u.ini}</span>
                <span className={s.picTx}><b>{u.k}</b><span>{u.s}</span></span>
              </div>
            ))}
          </Section>
        </div>
      </div>
      <footer className={s.foot}>
        <button type="button" className={`${s.fb} ${s.fbErr}`} onClick={() => say('Dead run: chọn lý do ở bản có ghi')}><IconTruck size={16} stroke={1.8} aria-hidden="true" />Dead run</button>
        <span className={s.sp} />
        <button type="button" className={s.fb} onClick={() => say('Đã gửi lệnh cắt mooc (giả lập)')}><IconScissors size={16} stroke={1.8} aria-hidden="true" />{t('tms.cutTrailer')}</button>
        <button type="button" className={`${s.fb} ${s.fbPri}`} onClick={() => { setTruck('51D-512.83'); say(`Đã gán 51D-512.83 cho ${d.id}`); }}><IconArrowsExchange size={16} stroke={1.8} aria-hidden="true" />{t('tms.swapTruck')}</button>
      </footer>
    </div>
  );
}
